"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.AddCatalogueOfferEvent = void 0;
const Name = exports.Name = 'add-catalogue-offer';
const AddCatalogueOfferEvent = exports.AddCatalogueOfferEvent = Name;
